import { BOOLEAN_OPTIONS } from "@/constant/GeneralOptions/boolean";
import { STATUS } from "@/constant/statusConstants";

export const TeamGroupInitialValues = (localeCodes, showData) => ({
  sport_id: showData?.data?.sport?.id || "",
  parent_id: showData?.data?.parent?.id || "",
  code: showData?.data?.code || "",
  localizations: localeCodes.reduce((acc, localeCode) => {
    acc[localeCode] = showData?.data?.localization_contents?.[localeCode] ?? "";
    return acc;
  }, {}),
  icon: null,
  is_icon_bordered: showData?.data?.is_icon_bordered ?? BOOLEAN_OPTIONS.NO,
  status: showData?.data?.status || STATUS.INACTIVE,
});
